import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';

import { fetchDigitalWalletEligibleCards } from '@domain/digital-wallet';
import { AndroidDigitalWalletCard, CardType } from '@generated-types';

const GOOGLE_WALLET_ELIGIBLE_CARDS = 'GOOGLE_WALLET_ELIGIBLE_CARDS';

export const useGoogleWalletEligibleCards = <T = AndroidDigitalWalletCard[]>(
    walletInfoResult: GtpWalletInfoResult,
    type: CardType,
    options?: Omit<UseQueryOptions<AndroidDigitalWalletCard[], Error, T>, 'queryKey' | 'queryFn'>,
) =>
    useQuery({
        queryKey: [GOOGLE_WALLET_ELIGIBLE_CARDS, walletInfoResult, type],
        queryFn: () => fetchDigitalWalletEligibleCards(walletInfoResult, type),
        ...options,
    });
